import { State } from '../../models/state';

export abstract class IStateService {
    abstract GetAllState(): State[];
}
